// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"64":"386c7c3a","238":"86476e15","280":"0ca8f2ed","584":"b870f1e2","878":"1e48af5e","954":"abbdd3f2","957":"0e85e12d"}[chunkId] + ".js";
};